import { useMemo } from "react";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectDefectFailed } from "../../store/selectors/defectSelectors";
import { Defect } from "../../types/defect"
import { formatDefectId } from "@idwal/idwal-utilities/lib/helpers";
import { Tooltip } from "primereact/tooltip";

export const DefectIdBody = (defect: Defect) => {

    const failed = useAppSelector(selectDefectFailed);

    const hasFailed = useMemo(() => (
        failed.includes(defect.defectId)
    ), [failed]);
     
    return (
        <span className="flex justify-content-left align-items-center">
            {formatDefectId(defect.defectId)}
            {hasFailed ? (
                <>
                <Tooltip target=".table-item-failed" />
                <span 
                    className="pi pi-exclamation-circle ml-2 table-item-failed"
                    data-pr-tooltip="Failed to update. Please retry."
                    data-pr-position="right"
                    data-pr-my="left center-2"
                />
                </>
            ) : null}
        </span>
    );
}